module.exports = __webpack_public_path__ + "static/media/apartment9.4c96dc02.jpg";